export default {
  // 頁面標題
  title: "調證建議",

  // 統計信息
  statistics: {
    totalPrefix: "共計",
    totalSuffix: "條數據",
  },

  // 複選框
  hideNonKeyPoint: "隱藏非重點調證",

  // 按鈕
  downloadChecklist: "下載調證清單",

  // 加載和空狀態
  loading: "拼命加載中",
  empty: "暫無數據",
  emptyTip: "請在畫布中選擇節點後右鍵或者點擊右側的加入調證按鈕",

  // 調證優先級
  priority: {
    normal: "普通調證",
    high: "重點調證",
  },

  // 調證狀態
  status: {
    pending: "待調證",
    success: "調證成功",
    failed: "調證失敗",
    waiting: "待調證返回",
  },
};
